module.exports = __webpack_public_path__ + "static/employee_handbook-55f85e44029b6862695dcf6dc8aaa9c0.png";